module.exports = __webpack_public_path__ + "img/pdf-cover.dd3d6a61.webp";